module.exports = __webpack_public_path__ + "fonts/Roboto-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/Roboto-Light.woff
// module id = 3459
// module chunks = 0